import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';

export function useCheckProfessionals(
  check: 'pool' | 'unallocated',
  search: string,
  date: string | undefined,
) {
  return useQuery(allocationQueries.checkProfessionals(check, search, date));
}
